import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import cs from 'classnames';
import Styles from '../../../Styles.module.scss';

export default function Kill() {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={Styles.CommandCard}>
            <div className={Styles.CommandHeader} onClick={() => setExpanded(!expanded)}>
                <div>
                    <span className={Styles.CommandName}>modelpark kill</span>
                    <span className={Styles.CommandSummary}>Force stop an app</span>
                </div>
                <DownOutlined className={cs(Styles.CommandExpandIcon, { [Styles.expanded]: expanded })} />
            </div>

            {expanded && (
                <div className={Styles.CommandBody}>
                    <p className={Styles.CommandDescription}>
                        Send SIGKILL to immediately terminate a running background app.
                        Unlike <code>modelpark stop</code>, this does not give the process time to clean up.
                    </p>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Options</div>
                        <table className={Styles.OptionsTable}>
                            <thead>
                                <tr>
                                    <th>Flag</th>
                                    <th>Default</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>--all</td>
                                    <td>false</td>
                                    <td>Kill all running apps</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Examples</div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Kill a single app</code>
                            <br />
                            <code>modelpark kill myapp</code>
                        </div>
                        <div className={Styles.CodeBlock}>
                            <code># Kill all running apps</code>
                            <br />
                            <code>modelpark kill --all</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Output</div>
                        <div className={Styles.CodeBlock}>
                            <code>{`Killed 'myapp' (pid 12345)`}</code>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
